<template>
    <CustomSelectOne :name="name" :items="items" :empty-value="emptyValue" v-model="internalValue"
                     item-label="name" item-value="id" :label="label" v-if="loading" :required="required"
                     :placeholder="placeholder" :filter="filter" :rules="rules"
                     :noPlaceholder="noPlaceholder"/>
</template>

<script>
    import CustomSelectOne from "./inner/CustomSelectOne";
    import {getAllCities} from "@/swagger/vue-api-client";

    export default {
        name: "CustomSelectOneCity",

        components: {CustomSelectOne},

        props: {
            name: {
                type: String,
            },
            label: {
                type: String,
            },
            emptyValue: {
                type: Boolean,
                default: false,
            },
            modelValue: null,
            disabled: {
                type: Boolean,
                default: false,
            },
            required: {
                type: Boolean,
                default: false,
            },
            placeholder: {
                type: String,
                default: "",
            },
            filter: {
                type: Boolean,
                default: false,
            },
            rules: undefined,
            noPlaceholder: {
                type: Boolean,
                default: false,
            },
        },

        emits: ["update:modelValue"],

        computed: {
            internalValue: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit("update:modelValue", value);
                },
            },
        },

        data() {
            return {
                items: [],
                loading: false,
            };
        },

        beforeMount() {
            getAllCities().then((response) => {
                this.items = response.data.map(item => ({id: item, name: item}));
                this.loading = true;
            });
        }
    };
</script>

<style lang="scss">
</style>
